<p-dialog header="{{title}}" [(visible)]="display" [responsive]="true" showEffect="fade" [modal]="true"
  (onHide)="close()" [draggable]="false" [maximizable]="true" [closeOnEscape]="false" [style]="{width: '500px'}"
  positionTop=100>
  <div class="loading-indicator">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="1" *ngIf="loading"></p-progressSpinner>
  </div>
  <div class="p-grid" *ngIf="!loading">
    <div class="p-col-12">

      <p-table *ngIf="!loading" [value]="data" sortField="GroupName" sortMode="single">
          <ng-template pTemplate="header">
            <tr> <th>Selected Categories</th> </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr class="ui-widget-header" *ngIf="rowGroupMetadata[rowData.GroupName].index === rowIndex && group">
              <td>
                  <span style="font-weight:bold">{{rowData.GroupName}}</span>
              </td>
            </tr>
            <tr *ngIf="rowData.Selected">
              <td>
                <div class="ml-5"> {{rowData.ChildName}} </div>
              </td>
            </tr>
          </ng-template>
      </p-table>

    </div>
  </div>
</p-dialog>